/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'coloring-slider-cloud': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_coloring-slider-cloud_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_coloring-slider-cloud_a)"><path pid="1" d="M39.082 21.287a10.238 10.238 0 00.47-2.923 10.35 10.35 0 00-19.929-3.922 7.011 7.011 0 00-10.9 5.837v.036h0a8.219 8.219 0 000 16.438h26.561a8.193 8.193 0 003.8-15.465z" _fill="none" _stroke="#000" stroke-miterlimit="10"/></g>`
  }
})
/* tslint:enable */
